import { LocalDate } from '@js-joda/core';

import { usePaidBreakExceptionStore } from '#/shared/stores/paidBreakExceptionStore';

/**
 * Validates that all paid break exceptions in the store have been decided (accepted or rejected).
 * @returns An object with isValid flag and array of dates that need decisions
 */
export const validatePaidBreakExceptions = (): {
  isValid: boolean;
  invalidDates: string[];
} => {
  const exceptions = usePaidBreakExceptionStore.getState().exceptions;
  const invalidDates: string[] = [];

  Object.entries(exceptions).forEach(([dateString, exception]) => {
    if (exception && (exception.approverDecision === 'pending' || exception.approverDecision === 'error')) {
      invalidDates.push(dateString);
    }
  });

  return {
    isValid: invalidDates.length === 0,
    invalidDates,
  };
};

/**
 * Sets all non accepted/rejected exceptions to 'error' state
 * @param shiftDates - Array of date strings (YYYY-MM-DD) to set to error state
 */
export const setExceptionsToError = (shiftDates: string[]): void => {
  const setExceptionDecision = usePaidBreakExceptionStore.getState().setExceptionDecision;

  shiftDates.forEach(shiftDate => {
    const date = LocalDate.parse(shiftDate);
    setExceptionDecision(date, 'error');
  });
};
